import Immutable from 'immutable';
import {
  CLEAR_FUEL_REPORT_PREVIEW,
  FLAG_FUEL_REPORT_PREVIEW_ACTIVITY,
  GET_FUEL_REPORT_PREVIEW,
} from '../../../actions/types';
import { FUEL_REPORT_PREVIEW_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(FUEL_REPORT_PREVIEW_SHAPE),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_FUEL_REPORT_PREVIEW_ACTIVITY:
      // raising flag
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      // lowering flag
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_FUEL_REPORT_PREVIEW:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_FUEL_REPORT_PREVIEW:
      return state.setIn(
        ['current', 'content'],
        INITIAL_STATE.getIn(['current', 'content']),
      );
    default:
      return state;
  }
};
